import { Toaster as Sonner, type ToasterProps } from "sonner";

/**
 * Toast host (shadcn `sonner` variant). Kept theme-library-free: the tool ships
 * a single light theme for now, so the Toaster is pinned to "light" rather than
 * pulling in next-themes. Mounted once in the app root; `toast(...)` from
 * "sonner" is called from mutation handlers.
 */
function Toaster(props: ToasterProps): JSX.Element {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
